import axios from "axios";
import { normalizePersonName } from "../utils/personName";

export default {
  data() {
    return {
      personsInCharge: [],
      accountDefaults: { nextcloudquota: null },
      investigator: {
        id: null,
        name: "",
        person: {
          preferred_name: {
            given_name: "",
            family_name: ""
          },
          alt_name: {
            given_name: "",
            family_name: ""
          },
          email: [""],
          incharge: [],
          id_number: {
            type: "",
            value: ""
          },
          gender: undefined,
          number: "",
          research_areas: [],
          hidden: false,
          featured: false,
          admin: false,
          comments: null,
          citicenship: [""],
        },
        account: {
          person: undefined,
          username: "",
          category_website: { gl: "", es: "", en: "" },
          preferred_language: "",
          picture_website: "",
          picture_website_private: false,
          picture_website_temporary: false,
          pubkey: [""],
          picture_account: "",
          activation_status: false,
          expiration_date: "",
          nextcloudquota: null,
          services: [],
          addServices: [],
          removeServices: []
        },
        vinculation: {
          category: "",
          type: "",
          start_date: "",
          end_date: ""
        },
        affiliation: {
          organization: "",
          end_date: "",
          start_date: ""
        },
        workplaceAssignation: {
          id: null,
          expiration_date: "",
          change_fast: false,
          change_date: ""
        },
        vacation: {
          type: "",
          start_date: "",
          end_date: "",
          days_count: ""
        }
      }
    };
  },

  created() {
    this.loadAccountDefaults();
  },

  computed: {
    identificationOptions() {
      return [
        {text: this.$t("form.id_number.dni"), value: "dni"},
        {text: this.$t("form.id_number.nie"), value: "nie"},
        {text: this.$t("form.id_number.passport"), value: "passport"},
      ];
    },
  },

  methods: {
    normalizePersonNameField(name, field) {
      name[field] = normalizePersonName(name[field]);
    },
    applyAccountQuotaDefault() {
      const quota = this.investigator.account.nextcloudquota;
      if ((quota === null || quota === undefined || quota === '') && this.accountDefaults.nextcloudquota !== null) {
        this.investigator.account.nextcloudquota = this.accountDefaults.nextcloudquota;
      }
    },
    async loadAccountDefaults() {
      try {
        const { data } = await axios.get(this.$store.state.endpoint + '/utils/accountDefaults');
        if (typeof data.nextcloudquota !== 'number' || !Number.isFinite(data.nextcloudquota) || data.nextcloudquota < 0) return;
        this.accountDefaults.nextcloudquota = data.nextcloudquota;
        this.applyAccountQuotaDefault();
      } catch (error) {
        // An omitted quota still uses the model default when creating the account.
      }
    },
    getInvestigator(path) {
      axios
        .get(path)
        .then(response => {
          this.investigator.id = response.data.id;
          this.investigator.name =
            response.data.preferred_name.given_name +
            " " +
            response.data.preferred_name.family_name;
          this.investigator.person = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getInvestigatorName(path) {
      axios
        .get(path)
        .then(response => {
          this.investigator.id = response.data.id;
          this.investigator.name =
            response.data.preferred_name.given_name +
            " " +
            response.data.preferred_name.family_name;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getInvestigatorAndPersonsInCharge(path) {
      axios
        .get(path)
        .then(response => {
          this.investigator.id = response.data.id;
          this.investigator.name =
            response.data.preferred_name.given_name +
            " " +
            response.data.preferred_name.family_name;
          this.investigator.person = response.data;
          if(this.investigator.person.citicenship.length>0) this.citicenship = this.investigator.person.citicenship;
        })
        .finally(this.getPersonsInCharge)
        .catch(error => {
          console.log(error);
        });
    },

    getPersonsInCharge() {
      axios
        .get(this.$store.state.endpoint + "/personName")
        .then(response => {
          this.investigator.person.incharge.forEach(id => {
            const item = response.data.find(
              itemResponse => itemResponse.id === id
            );
            if (item !== undefined) {
              this.personsInCharge.push({
                id: item.id,
                name:
                  item.preferred_name.given_name +
                  " " +
                  item.preferred_name.family_name
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadDefaultPersonInCharge() {
      const path =
        this.$store.state.endpoint +
        "/person/" +
        this.$store.getters.user.person;
      axios
        .get(path)
        .then(response => {
          this.investigator.person.incharge.push({
            id: response.data.id,
            name: response.data.preferred_name.given_name + ' ' + response.data.preferred_name.family_name
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadDefaultDatesVinculation() {
      let start_date = new Date();
      start_date.setDate(1);
      start_date.setMonth(start_date.getMonth() + 1);
      this.investigator.vinculation.start_date = start_date
          .toISOString()
          .substr(0, 10);
      let end_date = new Date();
      end_date.setDate(1);
      end_date.setMonth(end_date.getMonth() + 1);
      end_date.setFullYear(end_date.getFullYear() + 1);
      this.investigator.vinculation.end_date = end_date
          .toISOString()
          .substr(0, 10);
    },
  }
};
